import { GeneralContext } from "@database/contexts";
import { useContext } from "react";

export const useControllers = ()=> {

    const { terms } = useContext(GeneralContext);

    return {
        terms
    }
}